import { Controller } from "@hotwired/stimulus"

const VIEWPORT_AND_EVERYTHING_BELOW = "0px 0px 10000% 0px"

export default class extends Controller {
  static values = { anchor: String }
  static classes = ["hidden"]

  connect() {
    this.observer = new IntersectionObserver(([entry]) => this.toggle(entry.isIntersecting), {
      rootMargin: VIEWPORT_AND_EVERYTHING_BELOW,
    })
    this.observer.observe(document.getElementById(this.anchorValue))
  }

  disconnect() {
    this.observer?.disconnect()
  }

  toggle(anchorInOrBelowView) {
    this.hiddenClasses.forEach((name) => this.element.classList.toggle(name, anchorInOrBelowView))
  }
}
